import React from 'react';
import { Card, CardContent, CardHeader, Divider, TextField } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { ISettingsGroups } from '../interfaces';

interface IProps {
  disabled?: boolean;
}

const TechMapSettings = ({ disabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<{ settings: ISettingsGroups }>();

  const {
    groupName,
    settings: [CREATE_APPLICATION_TECHMAP_CRON],
  } = values.settings[4];

  const field = (index: number) => `settings[4].settings[${index}].value`;

  return (
    <Card>
      <CardHeader title={groupName} />
      <Divider />

      <CardContent>
        <TextField
          type="time"
          variant="filled"
          label={CREATE_APPLICATION_TECHMAP_CRON.description}
          value={CREATE_APPLICATION_TECHMAP_CRON.value}
          disabled={disabled}
          onChange={(event) => setFieldValue(field(0), event.target.value)}
          fullWidth
        />
      </CardContent>
    </Card>
  );
};

export default TechMapSettings;
